import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Youtube, Instagram, Music2, MessageCircle, Mail } from "lucide-react";
import { BRAND, waLink } from "@/lib/constants";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#080D1A] border-t border-white/10 mt-12">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid md:grid-cols-12 gap-8 items-start">
          <div className="md:col-span-5">
            <img src={BRAND.logoMain} alt="Tati și Sofia" className="h-14 mb-4" />
            <div className="flex items-start gap-3">
              <span className="text-2xl leading-none mt-0.5">🇷🇴</span>
              <p className="text-[12.5px] text-[#A0AABF] leading-relaxed">
                <strong className="text-[#F8F8F4]">O Românie în care copiii au acces la ambii părinți.</strong><br />
                O Românie în care iubirea nu este considerată un pericol.
              </p>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] font-bold tracking-[0.25em] uppercase text-[#D4A63D] mb-3">Urmărește-ne</div>
            <div className="flex items-center gap-3">
              <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 grid place-items-center text-[#F8F8F4]/85 hover:text-[#1877F2] hover:bg-white/10 transition"><Facebook className="w-4 h-4" /></a>
              <a href="#" aria-label="YouTube" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 grid place-items-center text-[#F8F8F4]/85 hover:text-[#FF0000] hover:bg-white/10 transition"><Youtube className="w-4 h-4" /></a>
              <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 grid place-items-center text-[#F8F8F4]/85 hover:text-[#E4405F] hover:bg-white/10 transition"><Instagram className="w-4 h-4" /></a>
              <a href="#" aria-label="TikTok" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 grid place-items-center text-[#F8F8F4]/85 hover:text-[#E89BB8] hover:bg-white/10 transition"><Music2 className="w-4 h-4" /></a>
              <a href={waLink()} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="w-10 h-10 rounded-full bg-[#25D366] grid place-items-center text-[#0A1020] hover:scale-110 transition"><MessageCircle className="w-4 h-4" /></a>
            </div>
            <a href="mailto:contact@tatisisofia.ro" className="text-[12px] text-[#A0AABF] hover:text-[#D4A63D] flex items-center gap-2 mt-4"><Mail className="w-3.5 h-3.5" /> contact@tatisisofia.ro</a>
          </div>

          <div className="md:col-span-4 text-[11px] text-[#A0AABF]">
            <div className="grid grid-cols-2 gap-x-4 gap-y-1.5">
              <Link to="/tati-sofia" className="hover:text-[#D4A63D]">Despre noi</Link>
              <Link to="/contact" className="hover:text-[#D4A63D]">Contact</Link>
              <Link to="/articole" className="hover:text-[#D4A63D]">Articole</Link>
              <Link to="/video" className="hover:text-[#D4A63D]">Video</Link>
              <Link to="/petitii" className="hover:text-[#D4A63D]">Petiții</Link>
              <Link to="/legislatie" className="hover:text-[#D4A63D]">Legislație</Link>
              <Link to="/comunitate" className="hover:text-[#D4A63D]">Comunitate</Link>
              <Link to="/shop" className="hover:text-[#D4A63D]">Shop</Link>
              <Link to="/programare" className="hover:text-[#D4A63D]">Programare</Link>
              <Link to="/doneaza" className="hover:text-[#D4A63D]">Donează</Link>
              <Link to="/termeni" className="hover:text-[#D4A63D]">Termeni și condiții</Link>
              <Link to="/confidentialitate" className="hover:text-[#D4A63D]">Confidențialitate</Link>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-5 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-[#6C7A9C]">© {new Date().getFullYear()} TatiSiSofia.ro · Toate drepturile rezervate</p>
          <p className="text-[11px] text-[#6C7A9C] italic">Pentru copii. Pentru adevăr. Pentru iubire.</p>
        </div>
      </div>
    </footer>
  );
};
